import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { CargueFacturasComponent } from './CargueFacturas.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueMasivoFacturas',
        component: CargueFacturasComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueMasivoFacturas',
          nombreFormulario : 'Cargue Masivo Facturas'
        } 
    }
];

@NgModule({
    declarations: [
        CargueFacturasComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        CargueFacturasComponent
    ],
    bootstrap: [CargueFacturasComponent]
})

export class CargueMasivoFacturasModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueFacturasMasivos/CargueFacturas.module.ts